exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-item{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;-webkit-display:flex;-webkit-flex-direction:row;-webkit-justify-content:flex-start;-webkit-align-items:center;flex-wrap:nowrap;width:100%;height:40px;border-radius:6px;-webkit-border-radius:6px;background-color:#e7e9ef;margin:10px 0}.order-item-item{color:#7b7c80;font-size:17px;font-family:Rubik,sans-serif}.order-item-quantity{display:flex;justify-content:center;align-items:center;-webkit-display:flex;-webkit-justify-content:center;-webkit-align-items:center;text-align:center;font-weight:800;width:25px;height:25px;margin:5px;color:#7b7c80;border-radius:50%;-webkit-border-radius:50%}.order-item-name{font-weight:700}@media screen and (max-width:320px){.order-item{height:35px;margin:5px auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-231af06a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lines/Line.vue
// module id = 117
// module chunks = 0